module.exports = __webpack_public_path__ + "img/login.804d1a33.jpg";